<div class="dialog-certificate-detail">
    <h1>{{ data.title }}</h1>
    <div mat-dialog-content>
        <app-tree
            [title]="'Zertifikatsdetails'"
            [treeData]="data.treeData"
            [sortedKeys]="data.certKeys">
        </app-tree>
    </div>
    <div mat-dialog-actions>
        <button mat-button (click)="onClose()" class="btn_green" cdkFocusInitial>
            Schließen
        </button>
    </div>
</div>